<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <div class="row">
          <label class="col-sm-2 col-form-label">다국어보기</label>
          <div class="col-sm-4">
            <base-switch v-model="showTranslation" type="primary" on-text="ON" off-text="OFF" />
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">제목(목록용)</label>
          <div class="col-sm-10">
            <base-input placeholder="제목" v-model="title">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">경로</label>
          <div class="col-sm-10">
            <base-input placeholder="경로" v-model="path">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">제목</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-12">
                <base-input placeholder="제목" v-model="titleKo">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
            <div class="row" v-if="showTranslation">
              <div class="col-sm-12">
                <base-input placeholder="제목(영어)" v-model="titleEn">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
            <div class="row" v-if="showTranslation">
              <div class="col-sm-12">
                <base-input placeholder="제목(일본어)" v-model="titleJa">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>

        <!--        <div class="row">-->
        <!--          <div class="col-sm-4">-->
        <!--            <div class="row">-->
        <!--              <label class="col-sm-4 col-form-label">한국어 이미지</label>-->
        <!--              <div class="col-sm-8">-->
        <!--                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileId | blipImageUrl" @onChangeFileIds="onFileIdChange" />-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="col-sm-4">-->
        <!--            <div class="row">-->
        <!--              <label class="col-sm-4 col-form-label">영어 이미지</label>-->
        <!--              <div class="col-sm-8">-->
        <!--                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileEnId | blipImageUrl" @onChangeFileIds="onFileIdEnChange" />-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="col-sm-4">-->
        <!--            <div class="row">-->
        <!--              <label class="col-sm-4 col-form-label">일본어 이미지</label>-->
        <!--              <div class="col-sm-8">-->
        <!--                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileJaId | blipImageUrl" @onChangeFileIds="onFileIdJaChange" />-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="row">
          <label class="col-sm-2 col-form-label">상세설명</label>
          <div class="col-sm-8">
            <base-input placeholder="상세설명">
              <textarea class="form-control" rows="10" v-model="descriptionKo"></textarea>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="showTranslation">
          <label class="col-sm-2 col-form-label"></label>
          <div class="col-sm-8">
            <base-input placeholder="상세설명">
              <textarea class="form-control" rows="10" v-model="descriptionEn"></textarea>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="showTranslation">
          <label class="col-sm-2 col-form-label"></label>
          <div class="col-sm-8">
            <base-input placeholder="상세설명">
              <textarea class="form-control" rows="10" v-model="descriptionJa"></textarea>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">시간설정</label>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="시작시간">
                  <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="종료시간">
                  <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">아티스트아이콘</label>
          <div class="col-sm-4">
            <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileId | blipImageUrl" @onChangeFileIds="onFileIdChange" />
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">포토카드</label>
          <div class="col-sm-10">
            <base-button @click="addPhotoCard" type="success">+</base-button><base-button @click="deletePhotoCard" type="success">-</base-button>

            <draggable class="row" handle=" .handle" v-model="imageFileIds" @start="drag = true" @end="drag = false">
              <div v-for="(imageFileId, index) in imageFileIds" class="handle col-sm-2 custom-col">
                <BlipFileUploadZone
                  :upload-category="6"
                  :maxFiles="1"
                  :fileUrl="imageFileId | blipImageUrl"
                  @onChangeFileIds="onImageFileIdsChange($event, index)"
                />
              </div>
            </draggable>
          </div>
        </div>
      </card>
      <base-button native-type="submit" v-if="id != null" type="success">수정</base-button>
      <base-button native-type="submit" v-else type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, BaseSwitch, Card } from "@/components/index";
import { Toast } from "@/util/Toast";
import BlipFileUploadZone from "@/components/BlipFileUploadZone.vue";
import * as _ from "lodash";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    BaseSwitch,
    BlipFileUploadZone,
    Card,
    BaseInput,
  },
  async created() {
    if (!this.$route.query.unitId) {
      Toast.error("잘못된 접근입니다");
      this.$router.push({ path: "/" });
    }
    this.unitId = Number(this.$route.query.unitId);
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id);
      await this.getPhotoCardsById();
    }
  },
  data() {
    return {
      unitId: null,
      showTranslation: true,
      id: null,
      title: null,
      imageFileId: null,
      titleKo: null,
      titleEn: null,
      titleJa: null,
      descriptionKo: null,
      descriptionEn: null,
      descriptionJa: null,
      imageFileIds: [],
      startTime: null,
      endTime: null,
      path: null,
    };
  },
  methods: {
    onImageFileIdsChange(newFileIds, index) {
      this.imageFileIds[index] = newFileIds[0];
    },
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },

    async getPhotoCardsById() {
      const res = await this.$axios.get(`/quests/photoCards/${this.id}`);
      const data = res.data.data.event;
      const photoCards = res.data.data.photoCards;
      this.title = data.title;
      this.path = data.path;
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      this.imageFileId = data.imageFileId;
      if (data.titles) {
        const json = JSON.parse(data.titles);
        this.titleKo = _.find(json, { lang: "ko" }).title;
        this.titleEn = _.find(json, { lang: "en" }).title;
        this.titleJa = _.find(json, { lang: "ja" }).title;
      }
      if (data.descriptions) {
        const json = JSON.parse(data.descriptions);
        this.descriptionKo = _.find(json, { lang: "ko" }).description;
        this.descriptionEn = _.find(json, { lang: "en" }).description;
        this.descriptionJa = _.find(json, { lang: "ja" }).description;
      }
      if (photoCards.length > 0) {
        this.imageFileIds = photoCards.map((photoCard) => photoCard.imageFileId);
      }
    },

    addPhotoCard() {
      this.imageFileIds.push(null);
    },

    deletePhotoCard() {
      this.imageFileIds.splice(this.imageFileIds.length - 1, 1);
      this.$forceUpdate();
    },

    async onSubmit() {
      if (!this.title) {
        Toast.error("제목을 입력해주세요");
        return;
      }

      if (!this.path) {
        Toast.error("경로를 입력해주세요");
        return;
      }

      if (!this.startTime || !this.endTime) {
        Toast.error("시간을 입력해주세요");
        return;
      }

      const params = {
        unitId: this.unitId,
        imageFileId: this.imageFileId,
        imageFileIds: this.imageFileIds,
        title: this.title,
        titles: JSON.stringify([
          { lang: "ko", title: this.titleKo },
          { lang: "en", title: this.titleEn },
          { lang: "ja", title: this.titleJa },
        ]),
        // imageFileId: this.imageFileId,
        // imageFileEnId: this.imageFileEnId,
        // imageFileJaId: this.imageFileJaId,
        path: this.path,
        descriptions: JSON.stringify([
          { lang: "ko", description: this.descriptionKo },
          { lang: "en", description: this.descriptionEn },
          { lang: "ja", description: this.descriptionJa },
        ]),
        startTime: this.startTime,
        endTime: this.endTime,
      };
      try {
        if (this.id) {
          await this.$axios.put(`/quests/photoCards/${this.id}`, params).then(() => {
            Toast.success("수정되었습니다");
            this.$router.go(-1);
          });
        } else {
          await this.$axios.post(`/quests/photoCards`, params).then(() => {
            Toast.success("등록되었습니다");
            this.$router.go(-1);
          });
        }
      } catch (e) {
        Toast.error("중복된 경로가 존재합니다");
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
.custom-col {
  max-width: 20%;
  flex: 0 0 20%;
}
</style>
